import { JsonServiceClient } from '@servicestack/client';
import { store } from '..';
import { AuthenticationActions, IAuthenticationState } from '../store/modules/authentication';
import { RequestState } from '../store/modules';


declare let global: any; // populated from package.json/jest

if (typeof global === 'undefined') {
    (window as any).global = window;
}

const client = new JsonServiceClient(global.BaseUrl || '/');

client.exceptionFilter = (res: Response, error: any) => {
    if (res.status === 401) {
        const state = store.getState() as IAuthenticationState;
        if (state.authentication.loadState.state !== RequestState.Pending) {
            store.dispatch(AuthenticationActions.checkAuthentication())
        }
    }
};

export default client;


// WEBPACK FOOTER //
// ./src/api/client.ts